import React, { createContext, useState } from "react";

const CesiumContext = createContext();

export function CesiumContextProvider({ viewer, children }) {

    const [selectedEntity, setSelectedEntity] = useState();
    
    return (
        <CesiumContext.Provider value={{ viewer, selectedEntity, setSelectedEntity }}>
            {viewer !== null ? children : <></>}
        </CesiumContext.Provider>
    )
}

export default CesiumContext;